import React from "react";
import styles from "./DataTable.module.scss";

const DataTable = ({
  columns,
  data,
  getRowKey,
  onRowClick,
  emptyMessage = "No records found",
  compact = false,
  className = "",
  tableStyle,
  footerData,
  emphasizeFooter = false,
  isLoading = false,
  loadingRows = 5,
}) => {
  const getAlignClass = (align) => {
    if (align === "right") return styles.alignRight;
    if (align === "center") return styles.alignCenter;
    return "";
  };

  const getCellClass = (column) =>
    [getAlignClass(column.align), column.emphasize ? styles.emphasizedCell : "", column.hideOnMobile ? styles.hideOnMobile : ""]
      .filter(Boolean)
      .join(" ");

  const getMobileLabel = (column) => {
    if (column.mobileLabel !== undefined) {
      return column.mobileLabel;
    }

    return typeof column.label === "string" ? column.label : "";
  };

  const renderLoadingRows = () =>
    Array.from({ length: loadingRows }).map((_, rowIndex) => (
      <tr key={`loading-${rowIndex}`} className={styles.loadingRow}>
        {columns.map((column, columnIndex) => (
          <td
            key={`${column.key}-${columnIndex}`}
            data-label={getMobileLabel(column)}
            className={getCellClass(column)}
            style={column.cellStyle}
          >
            <span className={styles.skeletonCell} />
          </td>
        ))}
      </tr>
    ));

  return (
    <div className={`${styles.tablePanel} ${className}`}>
      <div className={styles.tableScroll}>
        <table
          className={`${styles.table} ${compact ? styles.compactTable : ""} ${
            emphasizeFooter ? styles.emphasizedFooter : ""
          }`}
          style={tableStyle}
        >
          <thead>
            <tr>
              {columns.map((column) => (
                <th
                  key={column.key}
                  style={column.headerStyle}
                  className={getAlignClass(column.align)}
                  data-hide-on-mobile={column.hideOnMobile || undefined}
                  onClick={column.onSort}
                >
                  <span
                    className={
                      column.onSort
                        ? styles.sortableHeader
                        : styles.headerContent
                    }
                  >
                    {column.label}
                    {column.sortIndicator ? column.sortIndicator : null}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              renderLoadingRows()
            ) : data && data.length ? (
              data.map((row, rowIndex) => (
                <tr
                  key={getRowKey ? getRowKey(row, rowIndex) : rowIndex}
                  onClick={onRowClick ? () => onRowClick(row) : undefined}
                  className={onRowClick ? styles.clickableRow : ""}
                >
                  {columns.map((column) => (
                    <td
                      key={column.key}
                      data-label={getMobileLabel(column)}
                      className={getCellClass(column)}
                      style={column.cellStyle}
                    >
                      {column.render ? column.render(row) : row[column.key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} className={styles.emptyCell}>
                  {emptyMessage}
                </td>
              </tr>
            )}
          </tbody>
          {footerData ? (
            <tfoot>
              <tr>
                {columns.map((column) => (
                  <td
                    key={column.key}
                    data-label={getMobileLabel(column)}
                    className={getCellClass(column)}
                    style={column.cellStyle}
                  >
                    {column.footer ? column.footer(footerData) : null}
                  </td>
                ))}
              </tr>
            </tfoot>
          ) : null}
        </table>
      </div>
    </div>
  );
};

export default DataTable;
